const XPRESS_ID_ORIGIN = 'xpressid',
  XPRESS_ID_EVENT_ERROR = 'error',
  XPRESS_ID_EVENT_PROCESS_CANCELED = 'ProcessCancelled',
  XPRESS_ID_EVENT_PROCESS_EVENTS = 'ProcessEvents',
  XPRESS_ID_EVENT_QR_ERROR = 'QRProcessOnboardingError',
  XPRESS_ID_EVENT_QR_FINISHED = 'QRProcessCompleted';

export {
  XPRESS_ID_EVENT_ERROR,
  XPRESS_ID_EVENT_PROCESS_CANCELED,
  XPRESS_ID_EVENT_PROCESS_EVENTS,
  XPRESS_ID_EVENT_QR_ERROR,
  XPRESS_ID_EVENT_QR_FINISHED,
  XPRESS_ID_ORIGIN,
};
